import { PropsWithChildren, useMemo } from 'react'
import {
  ThemeProvider as AntdThemeProvider,
  BrickJobsTheme,
  VivaldisTheme
} from '@vivaldis/ui'
import { APP_BRANDS, useAppBrand } from '@vivaldis/common'

export const ThemeProvider = ({ children }: PropsWithChildren<unknown>) => {
  const appBrand = useAppBrand()
  const theme = useMemo(
    () => (appBrand === APP_BRANDS.BrickJobs ? BrickJobsTheme : VivaldisTheme),
    [appBrand]
  )

  return <AntdThemeProvider theme={theme}>{children}</AntdThemeProvider>
}
